import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { Clock, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaPrazoAceiteExcedido = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('excedeu prazo de aceite') || 
           acaoLower.includes('excedeu prazo') ||
           acaoLower.includes('prazo de aceite excedido') ||
           acaoLower.includes('prazo de aceite expirado');
};

const getIconPrazoAceiteExcedido = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: Clock, color: 'var(--ce5293f)' };
};

export default function CardPrazoAceiteExcedido({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconPrazoAceiteExcedido(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const prazoAceiteExcedidoConfig = {
    tipo: 'prazo_aceite_excedido',
    detectaTipo: detectaPrazoAceiteExcedido,
    getIcon: getIconPrazoAceiteExcedido,
    temExpansao: () => true,
    Component: CardPrazoAceiteExcedido
};
